import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar'; // 1. IMPORTAMOS EL MENÚ INTELIGENTE
import { Book, PlusCircle } from 'lucide-react'; // Dejamos solo los íconos que usa esta pantalla

const Cursos = () => {
  const navigate = useNavigate();
  const [cursos, setCursos] = useState([]);
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');

  useEffect(() => {
    cargarCursos();
  }, []);

  const cargarCursos = async () => {
    const token = localStorage.getItem('token');
    if (!token) return navigate('/login');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Cursos`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) setCursos(await response.json());
    } catch (error) {
      console.error("Error cargando cursos:", error);
    }
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    
    const nuevoCurso = { nombre, descripcion, activo: true };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/Cursos`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(nuevoCurso)
      });

      if (response.ok) {
        setNombre('');
        setDescripcion('');
        cargarCursos();
        alert('¡Curso registrado con éxito!');
      } else {
        alert('Nota: Asegúrate de tener el método POST en tu CursosController de .NET');
      }
    } catch (error) {
      console.error("Error guardando curso:", error);
    }
  };

  // NOTA: Borré la función 'handleLogout' de aquí porque el Sidebar ya hace ese trabajo.

  return (
    <div className="min-h-screen bg-gray-100 flex">
      
      {/* 2. REEMPLAZAMOS TODO EL CÓDIGO VIEJO DEL MENÚ POR ESTA SOLA LÍNEA */}
      <Sidebar />

      {/* ÁREA PRINCIPAL */}
      <main className="flex-1 p-6 overflow-y-auto">
        <h1 className="text-2xl font-bold text-slate-800 mb-6 flex items-center gap-2">
          <Book className="text-blue-600" /> Gestión de Cursos
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Formulario */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 h-fit">
            <h2 className="text-lg font-medium text-slate-800 mb-4 flex items-center gap-2"><PlusCircle size={20}/> Nuevo Curso</h2>
            <form onSubmit={handleGuardar} className="space-y-4">
              <div>
                <label className="block text-sm text-slate-600 mb-1">Nombre de la Materia</label>
                <input type="text" required value={nombre} onChange={e => setNombre(e.target.value)} className="w-full p-2 border rounded outline-none focus:ring-2 focus:ring-blue-500" placeholder="Ej. Álgebra" />
              </div>
              <div>
                <label className="block text-sm text-slate-600 mb-1">Descripción (Opcional)</label>
                <textarea value={descripcion} onChange={e => setDescripcion(e.target.value)} className="w-full p-2 border rounded outline-none focus:ring-2 focus:ring-blue-500" placeholder="Breve descripción..." rows="3"></textarea>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700 font-medium">Guardar Curso</button>
            </form>
          </div>

          {/* Lista de Cursos */}
          <div className="md:col-span-2 bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-50 border-b text-sm text-slate-600">
                  <th className="p-4 font-medium">ID</th>
                  <th className="p-4 font-medium">Nombre del Curso</th>
                  <th className="p-4 font-medium">Descripción</th>
                  <th className="p-4 font-medium">Estado</th>
                </tr>
              </thead>
              <tbody>
                {cursos.map((curso) => (
                  <tr key={curso.id} className="border-b hover:bg-slate-50">
                    <td className="p-4 text-slate-500">#{curso.id}</td>
                    <td className="p-4 font-medium text-slate-800">{curso.nombre}</td>
                    <td className="p-4 text-slate-600 text-sm">{curso.descripcion || '-'}</td>
                    <td className="p-4"><span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs">Activo</span></td>
                  </tr>
                ))}
                {cursos.length === 0 && (<tr><td colSpan="4" className="p-8 text-center text-slate-500">No hay cursos registrados.</td></tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Cursos;